export default "__VITE_PUBLIC_ASSET__dcaea7fc__"